import { annotations } from '@esentai/core/features/users/serializer';

import { createPageSerializer } from '@/serializers';

export default createPageSerializer({
  ...annotations,
});
